import React from "react";
import { Switch, Form } from "antd";
import { Controller } from "react-hook-form";
import {getError } from "../../../utils/form";

const itemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    lg: { span: 10 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    lg: { span: 14 },
  },
};

const ControlledSwitch = ({ control, errors, name, label, required }) => {
  const error = getError({errors, name});
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value, name, ref } }) => (
        <Form.Item
          label={label}
          {...itemLayout}
          required={required}
          labelAlign="left"
          validateStatus={error ? "error" : "success"}
          help={error?.message}
        >
          <Switch checked={!!value} name={name} ref={ref} onChange={onChange} />
        </Form.Item>
      )}
    />
  );
};

export default ControlledSwitch;
